// import { Response, URLSearchParams } from '@angular/http';
// import { HttpClient } from '@angular/common/http';
// import { Injectable } from '@angular/core';
// import 'rxjs/add/operator/do';
// import 'rxjs/add/operator/catch';
// import 'rxjs/add/operator/share';
// import 'rxjs/add/operator/map';
// import { Observable } from 'rxjs/Observable';
// import { FamilyList, ModelSelectionFilter, SaveFavouritesParams, JobsiteSelectionFilter, ImplementTypeSortOrder, ImplementSelectionFilter, PerformSearchDigitalForm, DigtalFormSeachResult, FlagTypesVM, ComponentTypeSelectionFilter, SerialNOSelectionFilter, AssetSerialSelectionFilter, SaveFavouritesParamsDigitalForms, GETDashboardColumnsVM, BulkDeleteUploadForm, MachineForecastInspectionVM, MachineForecastInspectionSeachResult, ForecastInspectionAverageVM, ForecastInspectionStatsResult, InspectionEventSearchFiltersVM, InspectionEventSearchResultVM } from './favourite-dialog-modal';
// import { EQUIPMENTVM, FormCatListVMSafety, GenericIdName, GenericIdNameVMforEQUIPMENT, GETCrackSchematicVM, GETGenericIdName, SchematicDataVM, ImplementTypeVM } from '../setup-implement/setup-implement.model';
// import { DashboardFavourites, DashboardSearchFilter, EquipmentImplementDetails } from '../dashboard/dashboard.model';
// import { EquipmentSelectItem } from '../setup-equipment/setup-equipment.model';
// import { userAlertsVMDigitalForms } from '../entities/global/model';
// import { HttpParams } from '@angular/common/http';

// @Injectable()
// export class FavouriteDialogService {


//   availableFamilyList: FamilyList[];

//   private readonly API_BASE = 'api/Favourite/';
//   private readonly GET_FAMILY_LIST = this.API_BASE + 'getAllFamilyList';
//   private readonly GET_MODEL_FILTER=this.API_BASE+ 'GetModelsAvailable';
//   private readonly GET_SAVE_FAVOURITE = this.API_BASE+'SaveFavouriteDetails';
//   private readonly GET_LOAD_FAVOURITE = this.API_BASE+ 'LoadFavouriteDetails';
//   private readonly GET_JOBSITE_FILTER=this.API_BASE+ 'GeJobsiteAvailable';
//   private readonly GET_UPDATE_FAVOURITE = this.API_BASE+'UpdateeFavouriteDetails';
//   private readonly GET_LOAD_IMPLEMENTTYPE_SORT = this.API_BASE+'LoadImplementTypeSortOrder';
//   private readonly CREATE_UPLOAD_FORM = this.API_BASE+ 'CreateUploadForm';
//   private readonly CREATE_UPLOAD_FORM_FECR = this.API_BASE+ 'CreateUploadFormFECR';
//   private readonly DELETE_UPLOAD_FORM = this.API_BASE+ 'DeleteUploadForm';
//   private readonly BULK_DELETE_UPLOAD_FORM = this.API_BASE+ 'BulkDeleteUploadForm';
//   private readonly GET_FAMILY_FILTER_BY_CUSTOMER=this.API_BASE+ 'GetFamiliesForCustomer';




// //digital form services
// private readonly GetInspectorListInfo=this.API_BASE+'GetFormInspectorList';
// private readonly GetFlagTypesListInfo=this.API_BASE+'GetAvaiableFlagTypeList';


//   private readonly GetFormCategoryListInfo=this.API_BASE+'getFormCategoryList';
//   private readonly GetFormList=this.API_BASE+'LoadAvailableForms';
//   private readonly GetDigitalFormSearchResultData=this.API_BASE+'GetDigitalFormSearchResult';
//   private readonly GetDigitalAvailableFormSearchResultData=this.API_BASE+'GetDigitalAvailableFormSearchResult';
// private readonly GetCustomDateRangeListInfo=this.API_BASE+'GetCustomDateRangeListInfo';
   
//   constructor(private _http: HttpClient) { }

//   public getFamilyList() {
//     this._http.get(this.GET_FAMILY_LIST).map((data: Response) => {
//         return data.json() as FamilyList[]; }).toPromise().then(x => {
//         this.availableFamilyList = x;
//       })
//   }
//   public getllFamilyList(): Observable<FamilyList[]> {
//     return this._http.get(this.GET_FAMILY_LIST).share().map(
//       (response: Response) => <FamilyList[]>response.json()).catch(this.handleError);
//   }

//   public GetEquipmentAvailable(params: number[]): Observable<EquipmentSelectItem[]> {
//       return this._http.post('Api/GETDashboard/GetEquipmentAvailable', params).share().map(
//           (response: Response) => <EquipmentSelectItem[]>response.json()).catch(this.handleError);
//   }

//   public GetImplementsAvailable(params: ImplementSelectionFilter): Observable<GETGenericIdName[]> {
//     return this._http.post('Api/GETDashboard/GetImplementsAvailable', params).share().map(
//         (response: Response) => <GETGenericIdName[]>response.json()).catch(this.handleError);
// }
  
// public GetComponentTypesForSelectedImplements(params: ComponentTypeSelectionFilter): Observable<GenericIdName[]> {
//   return this._http.post('Api/GETDashboard/GetComponentTypesForSelectedImplements', params).share().map(
//       (response: Response) => <GenericIdName[]>response.json()).catch(this.handleError);
// }

// public GetAllImplementTypesAvailable(params: ImplementSelectionFilter): Observable<GenericIdName[]> {
//   return this._http.post('Api/GETDashboard/GetAllImplementTypesAvailable', params).share().map(
//       (response: Response) => <GenericIdName[]>response.json()).catch(this.handleError);
// }

// public GetAllImplementTypesAvailableWithGETTYpe(params: ImplementSelectionFilter): Observable<ImplementTypeVM[]> {
//   return this._http.post('Api/GETDashboard/GetAllImplementTypesAvailable', params).share().map(
//       (response: Response) => <ImplementTypeVM[]>response.json()).catch(this.handleError);
// }
// //     public GetImplementTypesAvailable(params: DashboardSearchFilter, favouriteId: number): Observable<GenericIdName[]> {
// //     return this._http.post('Api/GETDashboard/GetImplementTypesAvailable', params).share().map(
// //         (response: Response) => <GenericIdName[]>response.json()).catch(this.handleError);
// // }

// public GetImplementTypesAvailable(searchFilters: DashboardSearchFilter, favouriteId: number): Observable<GenericIdName[]> {
//   let options = {
//     params: new HttpParams().set('searchFilters', JSON.stringify(searchFilters))
//     .set('favouriteId', favouriteId.toString())
// };
//   return this._http.get('Api/GETDashboard/GetImplementTypesAvailable', options).share().map(
//       (response: Response) => <GenericIdName[]>response.json()).catch(this.handleError);
// }

// public GetImplementTypeSortOrder(favouriteId: number): Observable<ImplementTypeSortOrder[]> {
//   let options = {
//     params: new HttpParams().set('favouriteId', favouriteId.toString())
// };
//   return this._http.get(this.GET_LOAD_IMPLEMENTTYPE_SORT, options).share().map(
//       (response: Response) => <ImplementTypeSortOrder[]>response.json()).catch(this.handleError);
// }

// public GetModelsAvailable(params: ModelSelectionFilter): Observable<GenericIdName[]> {
//   return this._http.post(this.GET_MODEL_FILTER, params).share().map(
//       (response: Response) => <GenericIdName[]>response.json()).catch(this.handleError);
// }

// public SaveFavouriteDetails(params: SaveFavouritesParams): Observable<number> {
//   return this._http.post(this.GET_SAVE_FAVOURITE, params).share().map(
//       (response: Response) => <number>response.json()).catch(this.handleError);
// }

// public LoadFavouriteDetails(favouriteId: number): Observable<SaveFavouritesParams> {
//   let options = {
//     params: new HttpParams().set('favouriteId', favouriteId.toString())
// };
//   return this._http.get(this.GET_LOAD_FAVOURITE, options).share().map(
//       (response: Response) => <SaveFavouritesParams>response.json()).catch(this.handleError);
// }

// public GetjobsitesAvailable(params: JobsiteSelectionFilter): Observable<GenericIdName[]> {
//   return this._http.post(this.GET_JOBSITE_FILTER, params).share().map(
//       (response: Response) => <GenericIdName[]>response.json()).catch(this.handleError);
// }

// public GetFamiliesForSelectedCustomers(params: JobsiteSelectionFilter): Observable<GenericIdName[]> {
//   return this._http.post(this.GET_FAMILY_FILTER_BY_CUSTOMER, params).share().map(
//       (response: Response) => <GenericIdName[]>response.json()).catch(this.handleError);
// }

// public UpdateFavouriteDetails(params: SaveFavouritesParams): Observable<number> {
//   return this._http.post(this.GET_UPDATE_FAVOURITE, params).share().map(
//       (response: Response) => <number>response.json()).catch(this.handleError);
// }


// ///Digital form services

// public getFormCategoryList(): Observable<GenericIdName[]> {
//   return this._http.get(this.GetFormCategoryListInfo).share().map(
//       (response: Response) => <GenericIdName[]>response.json()).catch(this.handleError);
// }

// public getFormCategoryListForSafety(): Observable<FormCatListVMSafety[]> {
//   return this._http.get(this.GetFormCategoryListInfo).share().map(
//       (response: Response) => <FormCatListVMSafety[]>response.json()).catch(this.handleError);
// }

// public GetFormListAvailable(params: number[]): Observable<GenericIdName[]> {
//   return this._http.post(this.GetFormList, params).share().map(
//       (response: Response) => <GenericIdName[]>response.json()).catch(this.handleError);
// }

// public GetInspectorAvailable(): Observable<GenericIdName[]> {
//   return this._http.get(this.GetInspectorListInfo).share().map(
//       (response: Response) => <GenericIdName[]>response.json()).catch(this.handleError);
// }

// public GetCustomDateRangeTypes(): Observable<GenericIdName[]> {
//   return this._http.get(this.GetCustomDateRangeListInfo).share().map(
//       (response: Response) => <GenericIdName[]>response.json()).catch(this.handleError);
// }
// public GetFlagTypesAvailable(): Observable<FlagTypesVM[]> {
//   return this._http.get(this.GetFlagTypesListInfo).share().map(
//       (response: Response) => <FlagTypesVM[]>response.json()).catch(this.handleError);
// }

// public GetDigitalFormSearchResult(params: PerformSearchDigitalForm): Observable<DigtalFormSeachResult> {
//   return this._http.post(this.GetDigitalFormSearchResultData, params).share().map(
//       (response: Response) => <DigtalFormSeachResult>response.json()).catch(this.handleError);
// }

// public GetDigitalAvailableFormSearchResult(params: PerformSearchDigitalForm): Observable<DigtalFormSeachResult> {
//   return this._http.post(this.GetDigitalAvailableFormSearchResultData, params).share().map(
//       (response: Response) => <DigtalFormSeachResult>response.json()).catch(this.handleError);
// }

// public GetMachineInspectionForecastSearchResult(params: MachineForecastInspectionVM): Observable<MachineForecastInspectionSeachResult> {
//   return this._http.post('Api/ForecastInspection/GetMachineInspectionForecastSearchResult', params).share().map(
//       (response: Response) => <MachineForecastInspectionSeachResult>response.json()).catch(this.handleError);
// }

// public SaveUpdateScenario(params: ForecastInspectionAverageVM): Observable<ForecastInspectionStatsResult> {
//   return this._http.post('Api/ForecastInspection/SaveUpdateScenario', params).share().map(
//       (response: Response) => <ForecastInspectionStatsResult>response.json()).catch(this.handleError);
// }

// public CreateUploadForm(formId: number, EquipmentId:number,inspectiondate:string): Observable<number> {
//   let options = {
//     params: new HttpParams().set('formId', formId.toString())
//     .set('EquipmentId', EquipmentId.toString())
//     .set('InspectionDate', inspectiondate)
// };
//   return this._http.get(this.CREATE_UPLOAD_FORM, options).share().map(
//       (response: Response) => <number>response.json()).catch(this.handleError);
// }

// public CreateUploadFormInFECR(formId: number, Implement:number): Observable<number> {
//   let options = {
//     params: new HttpParams().set('formId', formId.toString())
//     .set('Implement', Implement.toString())
// };
//   return this._http.get(this.CREATE_UPLOAD_FORM_FECR, options).share().map(
//       (response: Response) => <number>response.json()).catch(this.handleError);
// }


// public DeleteFormUploadDigitalForm(UploadId: number): Observable<boolean> {
//   let options = {
//     params: new HttpParams().set('UploadId', UploadId.toString())
// };
//   return this._http.get(this.DELETE_UPLOAD_FORM, options).share().map(
//       (response: Response) => <boolean>response.json()).catch(this.handleError);
// }

// public BulkDeleteFormUploadDigitalForm(params: BulkDeleteUploadForm): Observable<boolean> {
  
//   return this._http.post(this.BULK_DELETE_UPLOAD_FORM,  params ).share().map(
//       (response: Response) => <boolean>response.json()).catch(this.handleError);
// }

// public GetSerialbyModelFamilyMake(params: SerialNOSelectionFilter): Observable<EquipmentSelectItem[]> {
//   return this._http.post('Api/GETDashboard/GetSerialbyModelFamilyMake', params).share().map(
//       (response: Response) => <EquipmentSelectItem[]>response.json()).catch(this.handleError);
// }


// public GetAssetSerialSelectedImplements(params: ComponentTypeSelectionFilter): Observable<GenericIdName[]> {
//   return this._http.post('Api/GETDashboard/GetAssetSerialSelectedImplements', params).share().map(
//       (response: Response) => <GenericIdName[]>response.json()).catch(this.handleError);
// }

// public GetAssetAltForSelectedSerial(params: AssetSerialSelectionFilter): Observable<GenericIdName[]> {
//   return this._http.post('Api/GETDashboard/GetAssetAltForSelectedSerial', params).share().map(
//       (response: Response) => <GenericIdName[]>response.json()).catch(this.handleError);
// }
// //  public async Task<IHttpActionResult> GetAssetAltForSelectedSerial([FromBody] AssetSerialSelectionFilter searchFilters)

// public GetImplementsTypesOnEquipmentForCrackView(params: ImplementSelectionFilter): Observable<GenericIdNameVMforEQUIPMENT[]> {
//   return this._http.post('Api/GETDashboard/GetImplementsTypesOnEquipmentForCrackView', params).share().map(
//       (response: Response) => <GenericIdNameVMforEQUIPMENT[]>response.json()).catch(this.handleError);
// }

// public GetImplementsTypesOnEquipmentForCrackView_(params: GenericIdNameVMforEQUIPMENT[]): Observable<GenericIdNameVMforEQUIPMENT[]> {
//   return this._http.post('Api/GETDashboard/GetImplementsTypesOnEquipmentForCrackView_', params).share().map(
//       (response: Response) => <GenericIdNameVMforEQUIPMENT[]>response.json()).catch(this.handleError);
// }

// public GetDetailsedCompartmentView_(implementID:number): Observable<GenericIdNameVMforEQUIPMENT[]> {
//   let options = {
//     params: new HttpParams().set('implementID', implementID.toString())
// };
//   return this._http.get('Api/GETDashboard/GetDetailsedCompartmentView_', options).share().map(
//       (response: Response) => <GenericIdNameVMforEQUIPMENT[]>response.json()).catch(this.handleError);
// }


// // public GetAllEquipmentsforImplement(implementID:number): Observable<EQUIPMENTVM[]> {
// //   let params: URLSearchParams = new URLSearchParams();
// //   params.set('implementID', implementID.toString());
// //   return this._http.get('Api/GETDashboard/GetAllEquipmentsforImplement', { search: params }).share().map(
// //       (response: Response) => <EQUIPMENTVM[]>response.json()).catch(this.handleError);
// // }


// public GetAllEquipmentsforImplement(EQIds: EquipmentImplementDetails, implementID:number): Observable<EQUIPMENTVM[]> {
//   let options = {
//     params: new HttpParams().set('implementID', implementID.toString())
// };
//   return this._http.post("api/GETDashboard/GetAllEquipmentsforImplement", EQIds, options).share().map(
//       (response: Response) => <EQUIPMENTVM[]>response.json()).catch(this.handleError);
// } 


// public SaveFavouriteDigitalFormSearch(params: SaveFavouritesParamsDigitalForms): Observable<number> {
//   return this._http.post('api/Favourite/SaveFavouriteDigitalFormSearch', params).share().map(
//       (response: Response) => <number>response.json()).catch(this.handleError);
// }


// public GetDigitalFormFavourites(): Observable<DashboardFavourites[]> {
//   return this._http.get('Api/Favourite/GetDigitalFormFavourites').share().map(
//       (response: Response) => <DashboardFavourites[]>response.json()).catch(this.handleError);
// }

// public LoadFavouriteDetails_DigitalForms(favouriteId: number): Observable<SaveFavouritesParamsDigitalForms> {
//   let options = {
//     params: new HttpParams().set('favouriteId', favouriteId.toString())
// };
//   return this._http.get('Api/Favourite/LoadFavouriteDetails_DigitalForms', options).share().map(
//       (response: Response) => <SaveFavouritesParamsDigitalForms>response.json()).catch(this.handleError);
// }

// public UpdateFavouriteDigitalForm(params: SaveFavouritesParamsDigitalForms): Observable<number> {
//   return this._http.post('Api/Favourite/UpdateFavouriteDigitalForm', params).share().map(
//       (response: Response) => <number>response.json()).catch(this.handleError);
// }

// public RemoveFavouriteDigitalSearch(favouriteId: number): Observable<boolean> {
//   let options = {
//     params: new HttpParams().set('favouriteId', favouriteId.toString())
// };
//   return this._http.get('Api/Favourite/RemoveFavouriteDigitalSearch', options).share().map(
//       (response: Response) => <boolean>response.json()).catch(this.handleError);
// }

// public getCurrentUserAlertsforDigitalForms(): Observable<userAlertsVMDigitalForms[]> {
//   return this._http.get("api/DigitalFormIdentity/getCurrentUserAlertsforDigitalForms").share().map(
//     (response: Response) => <userAlertsVMDigitalForms[]>response.json()).catch(this.handleError);
// }

// public getCurrentUserAlertsforDigitalFormsHistroy(): Observable<userAlertsVMDigitalForms[]> {
//   return this._http.get("api/DigitalFormIdentity/getCurrentUserAlertsforDigitalFormsHistroy").share().map(
//     (response: Response) => <userAlertsVMDigitalForms[]>response.json()).catch(this.handleError);
// }
// public changeAlertStartusDigitalForms( ID:number, status:number): Observable<boolean> {
//   let options = {
//     params: new HttpParams().set('ID', ID.toString())
//     .set('status', status.toString())
// };
//   return this._http.get("api/DigitalFormIdentity/changeAlertStartusDigitalForms", options).share().map(
//       (response: Response) => <boolean>response.json()).catch(this.handleError);
// } 

// public clearHistoryDigitalForms(): Observable<boolean> {
//   return this._http.get("api/DigitalFormIdentity/clearHistoryDigitalForms").share().map(
//       (response: Response) => <boolean>response.json()).catch(this.handleError);
// } 




// // public GetSchematicDataForImplement_Dashboard(ImplementIDs: GenericIdNameVMforEQUIPMENT[]): Observable<SchematicDataVM[]> {
// //   return this._http.post('Api/Implement/GetSchematicDataForImplement_Dashboard', ImplementIDs).share().map(
// //       (response: Response) => <SchematicDataVM[]>response.json()).catch(this.handleError);
// // }



// public GetSchematicDataForImplement_Dashboard(searchFilters: GETCrackSchematicVM): Observable<SchematicDataVM[]> {
//   return this._http.post('Api/GETDashboard/GetSchematicDataForImplement_Dashboard', searchFilters).share().map(
//       (response: Response) => <SchematicDataVM[]>response.json()).catch(this.handleError);
// }


// public LoadDashboardColumns(): Observable<GETDashboardColumnsVM[]> {
//   return this._http.get("api/Favourite/LoadDashboardColumns").share().map(
//     (response: Response) => <GETDashboardColumnsVM[]>response.json()).catch(this.handleError);
// }
// //  public async Task<List<LU_GETDashboardColumnsVM>> LoadDashboartColumnsFavourite(int favouriteId)


// public LoadDashboartColumnsFavourite( favouriteId:number): Observable<GETDashboardColumnsVM[]> {
//   let options = {
//     params: new HttpParams().set('favouriteId', favouriteId.toString())
// };
//   return this._http.get("api/Favourite/LoadDashboartColumnsFavourite", options).share().map(
//       (response: Response) => <GETDashboardColumnsVM[]>response.json()).catch(this.handleError);
// } 
// public LoadDashboardColumnsFavouriteforTable( favouriteId:number): Observable<GETDashboardColumnsVM[]> {
//   let options = {
//     params: new HttpParams().set('favouriteId', favouriteId.toString())
// }; 
//   return this._http.get("api/Favourite/LoadDashboardColumnsFavouriteforTable", options).share().map(
//       (response: Response) => <GETDashboardColumnsVM[]>response.json()).catch(this.handleError);
// }
//   private handleError(error: Response) {
//     console.error(error);
//     return Observable.throw(error.json().error || 'Server error');
//   }

//   public GetInspectionEventsSearchResult(searchFilters: InspectionEventSearchFiltersVM): Observable<InspectionEventSearchResultVM[]> {
//     return this._http.post('Api/Inspection/InspectionEvents', searchFilters).share().map(
//       (response: Response) => <InspectionEventSearchResultVM[]>response.json()).catch(this.handleError);
//   }
//   public GetInspection(Customer: number[], InspectionId: number): Observable<InspectionEventSearchResultVM[]> {
//     let queryParams = new HttpParams();
//     queryParams = queryParams.append("Customer", JSON.stringify(Customer));
//     queryParams = queryParams.append("InspectionId", InspectionId.toString());
//     return this._http.get('Api/Inspection/Inspections', { params: queryParams }).share().map(
//       (response: Response) => <InspectionEventSearchResultVM[]>response.json()).catch(this.handleError);
//   }


// }



import { Injectable } from '@angular/core';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/map';
import { FamilyList, ModelSelectionFilter, SaveFavouritesParams, JobsiteSelectionFilter, ImplementTypeSortOrder, ImplementSelectionFilter, PerformSearchDigitalForm, DigtalFormSeachResult, FlagTypesVM, ComponentTypeSelectionFilter, SerialNOSelectionFilter, AssetSerialSelectionFilter, SaveFavouritesParamsDigitalForms, GETDashboardColumnsVM, BulkDeleteUploadForm, MachineForecastInspectionVM, MachineForecastInspectionSeachResult, ForecastInspectionAverageVM, ForecastInspectionStatsResult, InspectionEventSearchFiltersVM, InspectionEventSearchResultVM } from './favourite-dialog-modal';
import { EQUIPMENTVM, FormCatListVMSafety, GenericIdName, GenericIdNameVMforEQUIPMENT, GETCrackSchematicVM, GETGenericIdName, SchematicDataVM, ImplementTypeVM } from '../setup-implement/setup-implement.model';
import { DashboardFavourites, DashboardSearchFilter, EquipmentImplementDetails } from '../dashboard/dashboard.model';
import { EquipmentSelectItem } from '../setup-equipment/setup-equipment.model';
import { Model, userAlertsVMDigitalForms } from '../entities/global/model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class FavouriteDialogService {


  availableFamilyList: FamilyList[];

  private readonly API_BASE = 'api/Favourite/';
  private readonly GET_FAMILY_LIST = this.API_BASE + 'getAllFamilyList';
  private readonly GET_MODEL_FILTER=this.API_BASE+ 'GetModelsAvailable';
  private readonly GET_SAVE_FAVOURITE = this.API_BASE+'SaveFavouriteDetails';
  private readonly GET_LOAD_FAVOURITE = this.API_BASE+ 'LoadFavouriteDetails';
  private readonly GET_JOBSITE_FILTER=this.API_BASE+ 'GeJobsiteAvailable';
  private readonly GET_UPDATE_FAVOURITE = this.API_BASE+'UpdateeFavouriteDetails';
  private readonly GET_LOAD_IMPLEMENTTYPE_SORT = this.API_BASE+'LoadImplementTypeSortOrder';
  private readonly CREATE_UPLOAD_FORM = this.API_BASE+ 'CreateUploadForm';
  private readonly CREATE_UPLOAD_FORM_FECR = this.API_BASE+ 'CreateUploadFormFECR';
  private readonly DELETE_UPLOAD_FORM = this.API_BASE+ 'DeleteUploadForm';
  private readonly BULK_DELETE_UPLOAD_FORM = this.API_BASE+ 'BulkDeleteUploadForm';
  private readonly GET_FAMILY_FILTER_BY_CUSTOMER=this.API_BASE+ 'GetFamiliesForCustomer';
  private readonly GET_ROPE_MODEL_FILTER=this.API_BASE+ 'GetRopeShovelModels';
  private readonly GET_FAMILY_FILTER_BY_JOBSITE=this.API_BASE+ 'GetFamiliesForCustomerAndJobsite';
  private readonly GET_FAMILY_FILTER_BY_FAMILY=this.API_BASE+ 'GetModelsForFamily';
  private readonly GET_MAKE_FILTER_BY_JOBSITE=this.API_BASE+ 'GetMakeForJobsite';
  private readonly GET_MAKE_FILTER_BY_FAMILY=this.API_BASE+ 'GetMakeForFamily';
  private readonly GET_MODEL_FILTER_BY_FAMILYNEW=this.API_BASE+ 'GetModelsForFamilyNew';
  private readonly GET_MODEL_FILTER_BY_MAKE=this.API_BASE+ 'GetModelsForMake';


//digital form services
private readonly GetInspectorListInfo=this.API_BASE+'GetFormInspectorList';
private readonly GetFlagTypesListInfo=this.API_BASE+'GetAvaiableFlagTypeList';


  private readonly GetFormCategoryListInfo=this.API_BASE+'getFormCategoryList';
  private readonly GetFormList=this.API_BASE+'LoadAvailableForms';
  private readonly GetDigitalFormSearchResultData=this.API_BASE+'GetDigitalFormSearchResult';
  private readonly GetDigitalAvailableFormSearchResultData=this.API_BASE+'GetDigitalAvailableFormSearchResult';
private readonly GetCustomDateRangeListInfo=this.API_BASE+'GetCustomDateRangeListInfo';
  private readonly GetDigitalAvailableFormSearchResultAdminData=this.API_BASE+'GetDigitalAvailableFormSearchResultAdmin';
   
  constructor(private _http: HttpClient) { }

  public getFamilyList() {
    this._http.get<FamilyList[]>(this.GET_FAMILY_LIST).subscribe(
      (data: FamilyList[]) => {
        this.availableFamilyList = data;
      },
      (error) => {
        console.error('Error fetching family list', error);
      }
    );
    // this._http.get(this.GET_FAMILY_LIST).map((data: Response) => {
    //     return data.json() as FamilyList[]; }).toPromise().then(x => {
    //     this.availableFamilyList = x;
    //   })
    }
  public getllFamilyList(): Observable<FamilyList[]> {
    return this._http.get<FamilyList[]>(this.GET_FAMILY_LIST).pipe(catchError(this.handleError));
    // return this._http.get(this.GET_FAMILY_LIST).share().map(
    //   (response: Response) => <FamilyList[]>response.json()).catch(this.handleError);
  }

  public GetEquipmentAvailable(params: number[]): Observable<EquipmentSelectItem[]> {
    return this._http.post<EquipmentSelectItem[]>('Api/GETDashboard/GetEquipmentAvailable', params).pipe(catchError(this.handleError));
      // return this._http.post('Api/GETDashboard/GetEquipmentAvailable', params).share().map(
      //     (response: Response) => <EquipmentSelectItem[]>response.json()).catch(this.handleError);
  }

  public GetImplementsAvailable(params: ImplementSelectionFilter): Observable<GETGenericIdName[]> {
    return this._http.post<GETGenericIdName[]>('Api/GETDashboard/GetImplementsAvailable', params).pipe(catchError(this.handleError));
    // return this._http.post('Api/GETDashboard/GetImplementsAvailable', params).share().map(
    //     (response: Response) => <GenericIdName[]>response.json()).catch(this.handleError);
}
  
public GetComponentTypesForSelectedImplements(params: ComponentTypeSelectionFilter): Observable<GenericIdName[]> {
  return this._http.post<GenericIdName[]>('Api/GETDashboard/GetComponentTypesForSelectedImplements', params).pipe(catchError(this.handleError));
    // return this._http.post('Api/GETDashboard/GetComponentTypesForSelectedImplements', params).share().map(
    //   (response: Response) => <GenericIdName[]>response.json()).catch(this.handleError);
}

public GetAllImplementTypesAvailable(params: ImplementSelectionFilter): Observable<GenericIdName[]> {
  return this._http.post<GenericIdName[]>('Api/GETDashboard/GetAllImplementTypesAvailable', params).pipe(catchError(this.handleError));
  // return this._http.post('Api/GETDashboard/GetAllImplementTypesAvailable', params).share().map(
  //     (response: Response) => <GenericIdName[]>response.json()).catch(this.handleError);
}

public GetAllImplementTypesAvailableWithGETTYpe(params: ImplementSelectionFilter): Observable<ImplementTypeVM[]> {
  return this._http.post<ImplementTypeVM[]>('Api/GETDashboard/GetAllImplementTypesAvailable', params).pipe(catchError(this.handleError));
  // return this._http.post('Api/GETDashboard/GetAllImplementTypesAvailable', params).share().map(
  //     (response: Response) => <ImplementTypeVM[]>response.json()).catch(this.handleError);
}
//     public GetImplementTypesAvailable(params: DashboardSearchFilter, favouriteId: number): Observable<GenericIdName[]> {
//     return this._http.post('Api/GETDashboard/GetImplementTypesAvailable', params).share().map(
//         (response: Response) => <GenericIdName[]>response.json()).catch(this.handleError);
// }

public GetImplementTypesAvailable(searchFilters: DashboardSearchFilter, favouriteId: number): Observable<GenericIdName[]> {
  const options = {
    params: new HttpParams()
      .set('searchFilters',JSON.stringify(searchFilters))
      .set('favouriteId', favouriteId.toString())
  };
  return this._http.get<GenericIdName[]>('Api/GETDashboard/GetImplementTypesAvailable', options).pipe(catchError(this.handleError));
  // let params = { searchFilters: searchFilters, favouriteId: favouriteId };
  // return this._http.get('Api/GETDashboard/GetImplementTypesAvailable', { search: params }).share().map(
  //     (response: Response) => <GenericIdName[]>response.json()).catch(this.handleError);
}

public GetImplementTypeSortOrder(favouriteId: number): Observable<ImplementTypeSortOrder[]> {
  const options = {
    params: new HttpParams()
      .set('favouriteId', favouriteId.toString())
  };
  return this._http.get<ImplementTypeSortOrder[]>(this.GET_LOAD_IMPLEMENTTYPE_SORT, options).pipe(catchError(this.handleError));
  // let params: URLSearchParams = new URLSearchParams();
  // params.set('favouriteId', favouriteId.toString());
  // return this._http.get(this.GET_LOAD_IMPLEMENTTYPE_SORT, { search: params }).share().map(
  //     (response: Response) => <ImplementTypeSortOrder[]>response.json()).catch(this.handleError);
}

public GetModelsAvailable(params: ModelSelectionFilter): Observable<GenericIdName[]> {
  return this._http.post<GenericIdName[]>(this.GET_MODEL_FILTER, params).pipe(catchError(this.handleError));
 
}

public SaveFavouriteDetails(params: SaveFavouritesParams): Observable<number> {
  return this._http.post<number>(this.GET_SAVE_FAVOURITE, params).pipe(catchError(this.handleError));
  // return this._http.post(this.GET_SAVE_FAVOURITE, params).share().map(
  //     (response: Response) => <number>response.json()).catch(this.handleError);
}

public LoadFavouriteDetails(favouriteId: number): Observable<SaveFavouritesParams> {
  const options = {
    params: new HttpParams()
      .set('favouriteId', favouriteId.toString())
  };
  return this._http.get<SaveFavouritesParams>(this.GET_LOAD_FAVOURITE, options).pipe(catchError(this.handleError));
  // let params: URLSearchParams = new URLSearchParams();
  // params.set('favouriteId', favouriteId.toString());
  // return this._http.get(this.GET_LOAD_FAVOURITE, { search: params }).share().map(
  //     (response: Response) => <SaveFavouritesParams>response.json()).catch(this.handleError);
}

public GetjobsitesAvailable(params: JobsiteSelectionFilter): Observable<GenericIdName[]> {
  return this._http.post<GenericIdName[]>(this.GET_JOBSITE_FILTER, params).pipe(catchError(this.handleError));
  // return this._http.post(this.GET_JOBSITE_FILTER, params).share().map(
  //     (response: Response) => <GenericIdName[]>response.json()).catch(this.handleError);
}

public GetFamiliesForSelectedCustomers(params: JobsiteSelectionFilter): Observable<GenericIdName[]> {
  return this._http.post<GenericIdName[]>(this.GET_FAMILY_FILTER_BY_CUSTOMER, params).pipe(catchError(this.handleError));
  // return this._http.post(this.GET_FAMILY_FILTER_BY_CUSTOMER, params).share().map(
  //     (response: Response) => <GenericIdName[]>response.json()).catch(this.handleError);
}

public UpdateFavouriteDetails(params: SaveFavouritesParams): Observable<number> {
  return this._http.post<number>(this.GET_UPDATE_FAVOURITE, params).pipe(catchError(this.handleError));
  // return this._http.post(this.GET_UPDATE_FAVOURITE, params).share().map(
  //     (response: Response) => <number>response.json()).catch(this.handleError);
}


///Digital form services

public getFormCategoryList(): Observable<GenericIdName[]> {
  return this._http.get<GenericIdName[]>(this.GetFormCategoryListInfo).pipe(catchError(this.handleError));
  // return this._http.get(this.GetFormCategoryListInfo).share().map(
  //     (response: Response) => <GenericIdName[]>response.json()).catch(this.handleError);
}

public getFormCategoryListForSafety(): Observable<FormCatListVMSafety[]> {
  return this._http.get<FormCatListVMSafety[]>(this.GetFormCategoryListInfo).pipe(catchError(this.handleError));
  //return this._http.get(this.GetFormCategoryListInfo).share().map(
   //   (response: Response) => <FormCatListVMSafety[]>response.json()).catch(this.handleError);
}

public GetFormListAvailable(params: number[]): Observable<GenericIdName[]> {
  return this._http.post<GenericIdName[]>(this.GetFormList, params).pipe(catchError(this.handleError));
  // return this._http.post(this.GetFormList, params).share().map(
  //     (response: Response) => <GenericIdName[]>response.json()).catch(this.handleError);
}

public GetInspectorAvailable(): Observable<GenericIdName[]> {
  return this._http.get<GenericIdName[]>(this.GetInspectorListInfo).pipe(catchError(this.handleError));
  // return this._http.get(this.GetInspectorListInfo).share().map(
  //     (response: Response) => <GenericIdName[]>response.json()).catch(this.handleError);
}

public GetCustomDateRangeTypes(): Observable<GenericIdName[]> {
  return this._http.get<GenericIdName[]>(this.GetCustomDateRangeListInfo).pipe(catchError(this.handleError));
  // return this._http.get(this.GetCustomDateRangeListInfo).share().map(
  //     (response: Response) => <GenericIdName[]>response.json()).catch(this.handleError);
}
public GetFlagTypesAvailable(): Observable<FlagTypesVM[]> {
  return this._http.get<FlagTypesVM[]>(this.GetFlagTypesListInfo).pipe(catchError(this.handleError));
  // return this._http.get(this.GetFlagTypesListInfo).share().map(
  //     (response: Response) => <FlagTypesVM[]>response.json()).catch(this.handleError);
}

public GetDigitalFormSearchResult(params: PerformSearchDigitalForm): Observable<DigtalFormSeachResult> {
  return this._http.post<DigtalFormSeachResult>(this.GetDigitalFormSearchResultData, params).pipe(catchError(this.handleError));
  // return this._http.post(this.GetDigitalFormSearchResultData, params).share().map(
  //     (response: Response) => <DigtalFormSeachResult>response.json()).catch(this.handleError);
}

public GetDigitalAvailableFormSearchResult(params: PerformSearchDigitalForm): Observable<DigtalFormSeachResult> {
  return this._http.post<DigtalFormSeachResult>(this.GetDigitalAvailableFormSearchResultData, params).pipe(catchError(this.handleError));
  //return this._http.post(this.GetDigitalAvailableFormSearchResultData, params).share().map(
      // (response: Response) => <DigtalFormSeachResult>response.json()).catch(this.handleError);
}

public GetDigitalAvailableFormSearchResultAdmin(params: PerformSearchDigitalForm): Observable<DigtalFormSeachResult> {
  return this._http.post<DigtalFormSeachResult>(this.GetDigitalAvailableFormSearchResultAdminData, params).pipe(catchError(this.handleError));
  //return this._http.post(this.GetDigitalAvailableFormSearchResultData, params).share().map(
      // (response: Response) => <DigtalFormSeachResult>response.json()).catch(this.handleError);
}

public GetMachineInspectionForecastSearchResult(params: MachineForecastInspectionVM): Observable<MachineForecastInspectionSeachResult> {
  return this._http.post<MachineForecastInspectionSeachResult>('Api/ForecastInspection/GetMachineInspectionForecastSearchResult', params).pipe(catchError(this.handleError));
  //return this._http.post('Api/ForecastInspection/GetMachineInspectionForecastSearchResult', params).share().map(
      // (response: Response) => <MachineForecastInspectionSeachResult>response.json()).catch(this.handleError);
}

public SaveUpdateScenario(params: ForecastInspectionAverageVM): Observable<ForecastInspectionStatsResult> {
  return this._http.post<ForecastInspectionStatsResult>('Api/ForecastInspection/SaveUpdateScenario', params).pipe(catchError(this.handleError));
  // return this._http.post('Api/ForecastInspection/SaveUpdateScenario', params).share().map(
  //     (response: Response) => <ForecastInspectionStatsResult>response.json()).catch(this.handleError);
}

public CreateUploadForm(formId: number, EquipmentId:number,inspectiondate:string, selectedInspectorsCsv: string): Observable<number> {
  const options = {
    params: new HttpParams()
    .set('formId', formId.toString())
    .set('EquipmentId', EquipmentId.toString())
    .set('InspectionDate', inspectiondate)
    .set('SelectedInspectorsCsv', selectedInspectorsCsv)
  };
  return this._http.get<number>(this.CREATE_UPLOAD_FORM, options).pipe(catchError(this.handleError));
  // let params: URLSearchParams = new URLSearchParams();
  // params.set('formId', formId.toString());
  // params.set('EquipmentId', EquipmentId.toString());
  // params.set('InspectionDate', inspectiondate);
  // return this._http.get(this.CREATE_UPLOAD_FORM, { search: params }).share().map(
  //     (response: Response) => <number>response.json()).catch(this.handleError);
}

public CreateUploadFormInFECR(formId: number, Implement:number): Observable<number> {
  const options = {
    params: new HttpParams()
    .set('formId', formId.toString())
    .set('Implement', Implement.toString())
  };
  return this._http.get<number>(this.CREATE_UPLOAD_FORM_FECR, options).pipe(catchError(this.handleError));
  // let params: URLSearchParams = new URLSearchParams();
  // params.set('formId', formId.toString());
  // params.set('Implement', Implement.toString());
  // return this._http.get(this.CREATE_UPLOAD_FORM_FECR, { search: params }).share().map(
  //     (response: Response) => <number>response.json()).catch(this.handleError);
}


public DeleteFormUploadDigitalForm(UploadId: number): Observable<boolean> {
  const options = {
    params: new HttpParams()
    .set('UploadId', UploadId.toString())
  };
  return this._http.get<boolean>(this.DELETE_UPLOAD_FORM, options).pipe(catchError(this.handleError));
  // let params: URLSearchParams = new URLSearchParams();
  // params.set('UploadId', UploadId.toString());
  // return this._http.get(this.DELETE_UPLOAD_FORM, { search: params }).share().map(
  //     (response: Response) => <number>response.json()).catch(this.handleError);
}

public BulkDeleteFormUploadDigitalForm(params: BulkDeleteUploadForm): Observable<boolean> {
  return this._http.post<boolean>(this.BULK_DELETE_UPLOAD_FORM, params).pipe(catchError(this.handleError));
  // return this._http.post(this.BULK_DELETE_UPLOAD_FORM,  params ).share().map(
  //     (response: Response) => <number>response.json()).catch(this.handleError);
}

public GetSerialbyModelFamilyMake(params: SerialNOSelectionFilter): Observable<EquipmentSelectItem[]> {
  return this._http.post<EquipmentSelectItem[]>('Api/GETDashboard/GetSerialbyModelFamilyMake', params).pipe(catchError(this.handleError));
  
}


public GetAssetSerialSelectedImplements(params: ComponentTypeSelectionFilter): Observable<GenericIdName[]> {
  return this._http.post<GenericIdName[]>('Api/GETDashboard/GetAssetSerialSelectedImplements', params).pipe(catchError(this.handleError));
  // return this._http.post('Api/GETDashboard/GetAssetSerialSelectedImplements', params).share().map(
  //     (response: Response) => <GenericIdName[]>response.json()).catch(this.handleError);
}

public GetAssetAltForSelectedSerial(params: AssetSerialSelectionFilter): Observable<GenericIdName[]> {
  return this._http.post<GenericIdName[]>('Api/GETDashboard/GetAssetAltForSelectedSerial', params).pipe(catchError(this.handleError));
  // return this._http.post('Api/GETDashboard/GetAssetAltForSelectedSerial', params).share().map(
  //     (response: Response) => <GenericIdName[]>response.json()).catch(this.handleError);
}
//  public async Task<IHttpActionResult> GetAssetAltForSelectedSerial([FromBody] AssetSerialSelectionFilter searchFilters)

public GetImplementsTypesOnEquipmentForCrackView(params: ImplementSelectionFilter): Observable<GenericIdNameVMforEQUIPMENT[]> {
  return this._http.post<GenericIdNameVMforEQUIPMENT[]>('Api/GETDashboard/GetImplementsTypesOnEquipmentForCrackView', params).pipe(catchError(this.handleError));
  // return this._http.post('Api/GETDashboard/GetImplementsTypesOnEquipmentForCrackView', params).share().map(
  //     (response: Response) => <GenericIdNameVMforEQUIPMENT[]>response.json()).catch(this.handleError);
}

public GetImplementsTypesOnEquipmentForCrackView_(params: GenericIdNameVMforEQUIPMENT[]): Observable<GenericIdNameVMforEQUIPMENT[]> {
  return this._http.post<GenericIdNameVMforEQUIPMENT[]>('Api/GETDashboard/GetImplementsTypesOnEquipmentForCrackView_', params).pipe(catchError(this.handleError));
  // return this._http.post('Api/GETDashboard/GetImplementsTypesOnEquipmentForCrackView_', params).share().map(
  //     (response: Response) => <GenericIdNameVMforEQUIPMENT[]>response.json()).catch(this.handleError);
}

public GetDetailsedCompartmentView_(implementID:number): Observable<GenericIdNameVMforEQUIPMENT[]> {
  const options = {
    params: new HttpParams()
      .set('implementID', implementID.toString())
  };
  return this._http.get<GenericIdNameVMforEQUIPMENT[]>('Api/GETDashboard/GetDetailsedCompartmentView_', options).pipe(catchError(this.handleError));
  // let params: URLSearchParams = new URLSearchParams();
  // params.set('implementID', implementID.toString());
  // return this._http.get('Api/GETDashboard/GetDetailsedCompartmentView_', { search: params }).share().map(
  //     (response: Response) => <GenericIdNameVMforEQUIPMENT[]>response.json()).catch(this.handleError);
}


// public GetAllEquipmentsforImplement(implementID:number): Observable<EQUIPMENTVM[]> {
//   let params: URLSearchParams = new URLSearchParams();
//   params.set('implementID', implementID.toString());
//   return this._http.get('Api/GETDashboard/GetAllEquipmentsforImplement', { search: params }).share().map(
//       (response: Response) => <EQUIPMENTVM[]>response.json()).catch(this.handleError);
// }


public GetAllEquipmentsforImplement(EQIds: EquipmentImplementDetails, implementID:number): Observable<EQUIPMENTVM[]> {
  const options = {
    params: new HttpParams()
      .set('implementID', implementID.toString())
  };
  return this._http.post<EQUIPMENTVM[]>('api/GETDashboard/GetAllEquipmentsforImplement', EQIds, options).pipe(catchError(this.handleError));
  // let params: URLSearchParams = new URLSearchParams();
  // params.set('implementID', implementID.toString());
  // return this._http.post("api/GETDashboard/GetAllEquipmentsforImplement", EQIds, {search: params}).share().map(
  //     (response: Response) => <EQUIPMENTVM[]>response.json()).catch(this.handleError);
} 


public SaveFavouriteDigitalFormSearch(params: SaveFavouritesParamsDigitalForms): Observable<number> {
  return this._http.post<number>('api/Favourite/SaveFavouriteDigitalFormSearch', params).pipe(catchError(this.handleError));
  // return this._http.post('api/Favourite/SaveFavouriteDigitalFormSearch', params).share().map(
  //     (response: Response) => <number>response.json()).catch(this.handleError);
}

public GetDigitalFormFavourites(): Observable<DashboardFavourites[]> {
  return this._http.get<DashboardFavourites[]>('Api/Favourite/GetDigitalFormFavourites').pipe(catchError(this.handleError));
  // return this._http.get('Api/Favourite/GetDigitalFormFavourites').share().map(
  //     (response: Response) => <DashboardFavourites[]>response.json()).catch(this.handleError);
}

public LoadFavouriteDetails_DigitalForms(favouriteId: number): Observable<SaveFavouritesParamsDigitalForms> {
  const options = {
    params: new HttpParams()
      .set('favouriteId', favouriteId.toString())
  };
  return this._http.get<SaveFavouritesParamsDigitalForms>('Api/Favourite/LoadFavouriteDetails_DigitalForms', options).pipe(catchError(this.handleError));
  // let params: URLSearchParams = new URLSearchParams();
  // params.set('favouriteId', favouriteId.toString());
  // return this._http.get('Api/Favourite/LoadFavouriteDetails_DigitalForms', { search: params }).share().map(
  //     (response: Response) => <SaveFavouritesParamsDigitalForms>response.json()).catch(this.handleError);
}

public UpdateFavouriteDigitalForm(params: SaveFavouritesParamsDigitalForms): Observable<number> {
  return this._http.post<number>('Api/Favourite/UpdateFavouriteDigitalForm', params).pipe(catchError(this.handleError));
  // return this._http.post('Api/Favourite/UpdateFavouriteDigitalForm', params).share().map(
  //     (response: Response) => <number>response.json()).catch(this.handleError);
}

public RemoveFavouriteDigitalSearch(favouriteId: number): Observable<boolean> {
  const options = {
    params: new HttpParams()
      .set('favouriteId', favouriteId.toString())
  };
  return this._http.get<boolean>('Api/Favourite/RemoveFavouriteDigitalSearch', options).pipe(catchError(this.handleError));
  // let params: URLSearchParams = new URLSearchParams();
  // params.set('favouriteId', favouriteId.toString());
  // return this._http.get('Api/Favourite/RemoveFavouriteDigitalSearch', { search: params }).share().map(
  //     (response: Response) => <boolean>response.json()).catch(this.handleError);
}

public getCurrentUserAlertsforDigitalForms(ModuleFor:number): Observable<userAlertsVMDigitalForms[]> {
  const options = {
    params: new HttpParams()
      .set('ModuleFor', ModuleFor.toString())
  };
  return this._http.get<userAlertsVMDigitalForms[]>('api/DigitalFormIdentity/getCurrentUserAlertsforDigitalForms', options).pipe(catchError(this.handleError));
}

public getCurrentUserAlertsforDigitalFormsHistroy(): Observable<userAlertsVMDigitalForms[]> {
  return this._http.get<userAlertsVMDigitalForms[]>('api/DigitalFormIdentity/getCurrentUserAlertsforDigitalFormsHistroy').pipe(catchError(this.handleError));
 
}
public changeAlertStartusDigitalForms( ID:number, status:number): Observable<boolean> {
  const options = {
    params: new HttpParams()
      .set('ID', ID.toString())
      .set('status', status.toString())
  };
  return this._http.get<boolean>('api/DigitalFormIdentity/changeAlertStartusDigitalForms', options).pipe(catchError(this.handleError));
  
} 

public clearHistoryDigitalForms(): Observable<boolean> {
  return this._http.get<boolean>('api/DigitalFormIdentity/clearHistoryDigitalForms').pipe(catchError(this.handleError));
  
} 




// public GetSchematicDataForImplement_Dashboard(ImplementIDs: GenericIdNameVMforEQUIPMENT[]): Observable<SchematicDataVM[]> {
//   return this._http.post('Api/Implement/GetSchematicDataForImplement_Dashboard', ImplementIDs).share().map(
//       (response: Response) => <SchematicDataVM[]>response.json()).catch(this.handleError);
// }



public GetSchematicDataForImplement_Dashboard(searchFilters: GETCrackSchematicVM): Observable<SchematicDataVM[]> {
  return this._http.post<SchematicDataVM[]>('Api/GETDashboard/GetSchematicDataForImplement_Dashboard', searchFilters).pipe(catchError(this.handleError));
  // return this._http.post('Api/GETDashboard/GetSchematicDataForImplement_Dashboard', searchFilters).share().map(
  //     (response: Response) => <SchematicDataVM[]>response.json()).catch(this.handleError);
}


public LoadDashboardColumns(): Observable<GETDashboardColumnsVM[]> {
  return this._http.get<GETDashboardColumnsVM[]>('api/Favourite/LoadDashboardColumns').pipe(catchError(this.handleError));
  // return this._http.get("api/Favourite/LoadDashboardColumns").share().map(
  //   (response: Response) => <GETDashboardColumnsVM[]>response.json()).catch(this.handleError);
}
//  public async Task<List<LU_GETDashboardColumnsVM>> LoadDashboartColumnsFavourite(int favouriteId)


public LoadDashboartColumnsFavourite( favouriteId:number): Observable<GETDashboardColumnsVM[]> {
  const options = {
    params: new HttpParams()
      .set('favouriteId', favouriteId.toString())
  };
  return this._http.get<GETDashboardColumnsVM[]>('api/Favourite/LoadDashboartColumnsFavourite', options).pipe(catchError(this.handleError));
  // let params: URLSearchParams = new URLSearchParams();
  // params.set('favouriteId', favouriteId.toString()); 
  // return this._http.get("api/Favourite/LoadDashboartColumnsFavourite", {search: params}).share().map(
  //     (response: Response) => <GETDashboardColumnsVM[]>response.json()).catch(this.handleError);
} 
public LoadDashboardColumnsFavouriteforTable( favouriteId:number): Observable<GETDashboardColumnsVM[]> {
  const options = {
    params: new HttpParams()
      .set('favouriteId', favouriteId.toString())
  };
  return this._http.get<GETDashboardColumnsVM[]>('api/Favourite/LoadDashboardColumnsFavouriteforTable', options).pipe(catchError(this.handleError));
  // let params: URLSearchParams = new URLSearchParams();
  // params.set('favouriteId', favouriteId.toString()); 
  // return this._http.get("api/Favourite/LoadDashboardColumnsFavouriteforTable", {search: params}).share().map(
  //     (response: Response) => <GETDashboardColumnsVM[]>response.json()).catch(this.handleError);
}
  private handleError(error: Response) {
    console.error(error);
    return Observable.throw(error || 'Server error');
  }

  public GetInspectionEventsSearchResult(searchFilters: InspectionEventSearchFiltersVM): Observable<InspectionEventSearchResultVM[]> {
    return this._http.post<InspectionEventSearchResultVM[]>('Api/Inspection/InspectionEvents', searchFilters).pipe(catchError(this.handleError));
  // return this._http.post('Api/Inspection/InspectionEvents', searchFilters).share().map(
  //     (response: Response) => <DigtalFormSeachResult>response.json()).catch(this.handleError);
  }
  public GetInspection(Customer: number[], InspectionId: number): Observable<InspectionEventSearchResultVM[]> {
    const options = {
      params: new HttpParams()
        .set('Customer', JSON.stringify(Customer))
        .set('InspectionId', InspectionId.toString())
    };
    return this._http.get<InspectionEventSearchResultVM[]>('Api/Inspection/Inspections', options).pipe(catchError(this.handleError));
    // let queryParams = new HttpParams();
    // queryParams = queryParams.append("Customer", JSON.stringify(Customer));
    // queryParams = queryParams.append("InspectionId", InspectionId.toString());
    // return this._http.get('Api/Inspection/Inspections', { params: queryParams }).share().map(
    //   (response: Response) => <DigtalFormSeachResult>response.json()).catch(this.handleError);
  }

  public GetRopeShovelModels(Id:number): Observable<Model[]> {
    const options = {
      params: new HttpParams()
        .set('Id', Id.toString())
    };
    return this._http.get<Model[]>(this.GET_ROPE_MODEL_FILTER, options).pipe(catchError(this.handleError));
   
  }

  public GetFamiliesForSelectedJobsite(Customer:number[], Jobsite : number[]): Observable<GenericIdName[]> {
    const body = {
      Customer: Customer,
      Jobsite: Jobsite
    };
  return this._http.post<GenericIdName[]>(this.GET_FAMILY_FILTER_BY_JOBSITE, body).pipe(catchError(this.handleError));
}
    public GetModelsForFamily(Customer:number[], Jobsite : number[]): Observable<GenericIdName[]> {
    const body = {
      Customer: Customer,
      Jobsite: Jobsite
    };
  return this._http.post<GenericIdName[]>(this.GET_FAMILY_FILTER_BY_FAMILY, body).pipe(catchError(this.handleError));
}

    public GetMakesForJobsite(Customer:number[], Jobsite : number[]): Observable<GenericIdName[]> {
    const body = {
      Customer: Customer,
      Jobsite: Jobsite
    };
  return this._http.post<GenericIdName[]>(this.GET_MAKE_FILTER_BY_JOBSITE, body).pipe(catchError(this.handleError));
}
    public GetMakesForFamily(Customer:number[], Jobsite : number[], Family : number[]): Observable<GenericIdName[]> {
    const body = {
      Customer: Customer,
      Jobsite: Jobsite,
      Family: Family
    };
  return this._http.post<GenericIdName[]>(this.GET_MAKE_FILTER_BY_FAMILY, body).pipe(catchError(this.handleError));
}

    public GetModelsForFamilyNew(Customer:number[], Jobsite : number[], Family : number[]): Observable<GenericIdName[]> {
    const body = {
      Customer: Customer,
      Jobsite: Jobsite,
      Family: Family,
    };
  return this._http.post<GenericIdName[]>(this.GET_MODEL_FILTER_BY_FAMILYNEW, body).pipe(catchError(this.handleError));
}
    public GetModelsForMake(Customer:number[], Jobsite : number[], Family : number[], Make: number[]): Observable<GenericIdName[]> {
    const body = {
      Customer: Customer,
      Jobsite: Jobsite,
      Family: Family,
      Make: Make
    };
  return this._http.post<GenericIdName[]>(this.GET_MODEL_FILTER_BY_MAKE, body).pipe(catchError(this.handleError));
}


public ChangeAlertStatusBulk( ModuleFor:number,status:number): Observable<boolean> {
  const options = {
    params: new HttpParams()
      .set('moduleFor', ModuleFor.toString())
      .set('status', status.toString())
  };
  return this._http.get<boolean>('api/DigitalFormIdentity/ChangeAlertStatusBulk', options).pipe(catchError(this.handleError));
  
} 

}
